function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconVolumeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.553 5.585A1.002 1.002 0 0119 6.48v19.04a1.002 1.002 0 01-1.447.895l-7.79-3.895H4a1 1 0 01-1-1V10.48a1 1 0 011-1h5.764l7.789-3.895zM11 11.098v9.804l6 3V8.098l-6 3zm15.428-3.381c4.434 4.434 4.434 11.649 0 16.083l-1.413-1.415c3.653-3.654 3.654-9.6 0-13.254l1.413-1.414zM24.18 9.964a8.14 8.14 0 012.4 5.795 8.141 8.141 0 01-2.4 5.795l-1.413-1.414a6.156 6.156 0 001.813-4.381c0-1.654-.643-3.21-1.813-4.38l1.413-1.415zM5 20.521h4V11.48H5v9.04zm16.877-8.253a4.942 4.942 0 010 6.981l-1.413-1.414c.555-.555.86-1.292.86-2.076 0-.785-.305-1.522-.86-2.077l1.413-1.414z",
    fill: props.color
  }));
}

export default SvgIconVolumeFilled;